import { INIT } from './view'
import * as ListsModes from '../const/ListsModes'

export const NAMESPACE = 'KanBo/MyBoard/listsMode/'
export const SET = NAMESPACE + 'SET'

const initialState = ListsModes.NORMAL

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return (action.payload && action.payload.changed) ? initialState : state
    case SET:
      return action.payload
    default: return state
  }
}

export function set (payload) {
  return {
    type: SET,
    payload
  }
}
